<template>
  <section v-loading="loading" class="!rounded-xl">
    <div
      class="flex flex-col md:flex-row items-start md:items-center justify-between gap-2 md:!gap-4 !px-3 !pb-2 border-b border-page-border sticky top-0 bg-container-background z-[1] !pt-3 !rounded-t-xl"
    >
      <div class="flex items-center !gap-3">
        <el-button
          @click="goBack"
          size="mini"
          class="bg-transparent !border border-black/20 hover:!border-brand-300 active:!border-brand-500 !py-[6px] !px-2 !rounded-sm hover:!bg-gray-100"
        >
          <span>
            <img src="@/assets/img/icons/new/left-back-icon.svg" alt="" class="!size-3" />
          </span>
        </el-button>
        <span
          class="!text-sm 2xl:!text-base !font-normal !text-black-950 !m-0 !max-w-64 2xl:!max-w-[500px] truncate"
        >
          Discussion Forums
        </span>
      </div>
    </div>

    <div class="grid grid-cols-1 md:!grid-cols-[2fr_1fr]">
      <div class="h-[calc(100vh-150px)] overflow-y-auto !box-border !pt-3 !px-4">
        <div>
          <!-- Avatar + Info -->
          <div class="flex items-center !gap-3 !mb-2">
            <!-- Avatar -->
            <div class="icon-block initial" style="margin-top: 2px">
              <div v-if="entityUserInfoData[forumData.created_by]?.avatar">
                <img
                  :src="entityUserInfoData[forumData.created_by].avatar"
                  alt="IMG"
                  width="45"
                  height="45"
                  style="border-radius: 50%; border: 1px solid #ddd"
                />
              </div>
              <div class="icon" v-else>
                <div class="initial-text">
                  <span>{{ getInitials(forumData) }}</span>
                </div>
              </div>
            </div>

            <!-- Name + Created Info -->
            <div class="flex flex-col">
              <!-- Name -->
              <span class="text-black-950 font-normal text-xs xl:text-smd 2xl:!text-base">
                {{
                  entityUserInfoData[forumData.created_by] == getAuthenticatedUser._id
                    ? 'You'
                    : entityUserInfoData?.[forumData.created_by]?.first_name +
                      ' ' +
                      entityUserInfoData?.[forumData.created_by]?.last_name
                }}
              </span>

              <!--  Date -->
              <span class="text-black-700 text-xs 2xl:text-sm font-normal">
                {{ forumData.created_at | getFormattedDateTypeThree }}
              </span>
            </div>
          </div>
          <!-- Title -->
          <span class="text-black-950 text-sm xl:!text-base 2xl:!text-lg font-normal block">
            {{ forumData.title }}
          </span>
          <div
            v-html="forumData.content"
            class="text-black-700 text-xs xl:text-[13px] 2xl:text-sm font-normal !mt-2"
          ></div>
          <div class="flex items-center !mt-2 flex-wrap">
            <span
              class="!bg-transparent !border-none !text-brand-500 !px-2 !py-1 !rounded-md text-xxs xl:!text-xs 2xl:!text-sm !font-normal cursor-pointer"
              style="color: var(--brand-500)"
              v-for="tag in forumData.tags"
              :key="tag"
              @click="openTag(tag)"
            >
              {{ tag }}
            </span>
          </div>

          <div
            class="mt-1 d-flex !w-fit !mr-auto justify-content-between align-items-center !border border-[#E5E5E5] !px-2 !py-0.5 !rounded-lg"
          >
            <!-- Like Button -->
            <div style="display: flex; align-items: center; gap: 5px">
              <img
                v-if="forumData.liked_by.includes(getAuthenticatedUser._id)"
                class="!size-3"
                src="../../../public/assets/img/icons/Like-Fill.svg"
                @click="dislike(index)"
              />
              <img
                v-else
                class="!size-3"
                src="../../../public/assets/img/icons/Like-Outline.svg"
                @click="like(index)"
              />
              <span class="text-[#68686A] text-xs font-normal">
                {{ forumData.liked_by.length }}
              </span>
            </div>
            <div
              style="width: 1px; height: 20px; background-color: #ccc; margin-inline: 0.75rem"
            ></div>
            <div style="display: flex; align-items: center; gap: 6px">
              <img src="@/assets/img/icons/new/forums/comment-icon.svg" alt="" class="!size-3" />
              <span class="text-[#68686A] text-xs font-normal">{{ totalComments }}</span>
            </div>

            <!-- Vertical Divider -->
            <!-- <div
                style="width: 1px; height: 20px; background-color: #ccc"
              ></div> -->

            <!-- Add Comment Button
              <el-button size="small" @click="addComment"
                >Add Comment</el-button
              > -->
          </div>
        </div>
        <div class="!mt-3 max-h-56 overflow-y-auto">
          <!-- <div class=" mb-2" id="comment-section">
           <span style="font-weight: bold">{{
             "Comments(" + totalComments + ")"
           }}</span>
         </div> -->
          <div>
            <div v-if="comments.length">
              <CommentBlock
                v-for="comment in comments"
                :key="comment._id"
                :comment="comment"
                :entityUserInfoData="entityUserInfoData"
                :level="0"
                @reply="reply"
              />
            </div>
            <div v-else class="centered">
              <span style="opacity: 70%">No Comments</span>
            </div>
          </div>
        </div>
        <div class="!mt-2 !mb-2" id="post-comment-section">
          <div class="d-flex align-items-center" style="gap: 10px">
            <!-- Avatar Block -->
            <div class="icon-block initial">
              <div v-if="entityUserInfoData[getAuthenticatedUser._id]?.avatar">
                <img
                  :src="entityUserInfoData[getAuthenticatedUser._id].avatar"
                  alt="IMG"
                  width="30"
                  height="30"
                  style="border-radius: 50%"
                />
              </div>
              <div class="icon" v-else>
                <div class="initial-text !text-red-500">
                  <span>{{ getInitials({ created_by: getAuthenticatedUser._id }) }}</span>
                </div>
              </div>
            </div>

            <!-- Text Block -->
            <div class="text-[#181616] text-xs xl:text-smd 2xl:!text-sm">
              <span v-if="replyToUser">
                {{
                  'Reply to ' +
                  (replyToUser == getAuthenticatedUser._id
                    ? 'yourself'
                    : entityUserInfoData?.[replyToUser]?.first_name +
                      ' ' +
                      entityUserInfoData?.[replyToUser]?.last_name)
                }}
              </span>
              <span v-else>Add Comment</span>
            </div>
          </div>

          <CkEditorOffline
            v-model="comment"
            :config="editorConfig"
            :editorId="editorConfig.id"
          ></CkEditorOffline>
          <el-button
            style="background: var(--brand-500) !important"
            class="!py-2 !px-4 !rounded-sm hover:!bg-brand-500 !border-none !m-0 float-right !mt-3 !h-auto !font-normal"
            type="primary"
            size="small"
            @click="postComment"
          >
            <span class="flex items-center !gap-1">
              <img src="@/assets/img/icons/new/send-icon.svg" alt="" class="!size-3" />
              {{ 'Post ' + (isNew ? 'Comment' : 'Reply') }}
            </span>
          </el-button>
        </div>
      </div>
      <div
        class="h-[calc(100vh-150px)] overflow-y-aut !box-border !pt-3 !px-4 !border-l !border-page-border"
      >
        <el-button
          style="background: var(--brand-500) !important"
          class="!py-2 w-full text-center text-xs !font-normal text-white !rounded-sm hover:!bg-brand-500 !border-none !m-0 !h-auto"
          @click="askQuestion"
        >
          Ask your question
        </el-button>
        <div class="tag-box mt-2">
          <div class="tag-header">
            <i class="el-icon-collection-tag"></i>
            <span>Related Articles</span>
          </div>
          <div class="tag-list min-h-12 max-h-56 overflow-y-auto">
            <div v-for="topic in relatedForums" :key="topic._id" class="tag-row">
              <div
                class="text-xs 2xl:text-sm text-black-700 hover:text-blue-600"
                @click="openForum(topic._id)"
                style="cursor: pointer"
              >
                {{ topic.title }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { postAPICall } from '../../helpers/httpHelper';
  import CommentBlock from './CommentBlock.vue';
  import { ckEditorConfig } from '@/assets/data/ckeditor_config.ts';
  export default {
    data() {
      return {
        forumData: {},
        comments: [],
        allComments: [],
        totalComments: 0,
        entityUserInfoData: {},
        loading: false,
        comment: '',
        isNew: true,
        replyToComment: '',
        replyToUser: '',
        editorConfig: ckEditorConfig,
        relatedForums: [],
      };
    },
    computed: {
      ...mapGetters('auth', ['getAuthenticatedUser']),
      isApplicationUser() {
        return this.$route.name == 'ApplicationUserForumDetailedView' ? true : false;
      },
    },
    components: {
      CommentBlock,
      CkEditorOffline: () => import('@/components/CkEditor.vue'),
    },
    async mounted() {
      await this.getNecessaryInfo();
    },
    methods: {
      async getNecessaryInfo() {
        this.loading = true;
        await postAPICall('GET', '/forums/mark-read-comments/' + this.$route.params.forum_id);
        let [forumData, forums] = await Promise.all([
          postAPICall('GET', '/forums/get-thread-by-id/' + this.$route.params.forum_id),
          postAPICall('GET', '/forums/related-threads/' + this.$route.params.forum_id),
          this.fetchComments(),
        ]);
        if (forums.data.length) {
          this.relatedForums = forums.data;
        }
        if (forumData.data) {
          this.forumData = forumData.data;
          this.replyToUser = forumData.created_by;
          if (
            this.forumData.created_by != this.getAuthenticatedUser._id &&
            !this.forumData.read_by.includes(this.getAuthenticatedUser._id)
          ) {
            await postAPICall('POST', '/forums/mark-thread-as-read/' + this.forumData._id, {});
          }
        }
        let usersInfo = [
          this.getAuthenticatedUser._id,
          forumData?.data?.created_by,
          ...this.allComments?.map((cmnt) => cmnt.created_by),
        ];
        let usersResponse = await postAPICall('POST', '/entities-data/users-info', {
          contact_ids: usersInfo,
          user_ids: usersInfo,
        });
        this.entityUserInfoData = {
          ...this.entityUserInfoData,
          ...usersResponse.data,
        };
        this.loading = false;
      },
      getInitials(forum) {
        let user = this.entityUserInfoData[forum.created_by];
        return (
          user?.first_name?.charAt(0)?.toUpperCase() + user?.last_name?.charAt(0)?.toUpperCase()
        );
      },
      buildCommentHierarchy(comments) {
        const map = {};
        const roots = [];

        // Initialize comment map with replies array
        for (const comment of comments) {
          map[comment._id] = { ...comment, replies: [] };
        }

        // Build tree structure
        for (const comment of comments) {
          if (comment.replied_to && map[comment.replied_to]) {
            map[comment.replied_to].replies.push(map[comment._id]);
          } else {
            roots.push(map[comment._id]);
          }
        }

        return roots;
      },
      async like() {
        const response = await postAPICall('POST', '/forums/like-thread/' + this.forumData._id);
        if (response.success) {
          this.forumData.liked_by.push(this.getAuthenticatedUser._id);
        } else {
          this.$message.error('Something went wrong !');
        }
      },
      async dislike() {
        const response = await postAPICall('POST', '/forums/dislike-thread/' + this.forumData._id);
        if (response.success) {
          this.forumData.liked_by.splice(
            this.forumData.liked_by.indexOf(this.getAuthenticatedUser._id),
            1
          );
        } else {
          this.$message.error('Something went wrong !');
        }
      },
      scrollToComments(id) {
        const section = document.getElementById(id);
        if (section) section.scrollIntoView({ behavior: 'smooth' });
        window.CKEDITOR.instances[this.editorConfig.id].focus();
      },
      reply(comment) {
        this.replyToComment = comment;
        this.replyToUser = this.allComments.find((c) => c._id == comment).created_by;
        this.isNew = false;
        this.scrollToComments('post-comment-section');
      },
      async postComment() {
        if (!this.comment) {
          this.$notify.error({
            title: 'Error',
            message: 'Comment cannot be empty. Please write something before submitting.',
          });
          return;
        }
        let response;
        if (this.replyToComment) {
          response = await postAPICall('POST', '/forums/reply-to-comment/' + this.replyToComment, {
            comment: this.comment,
          });
        } else {
          response = await postAPICall('POST', '/forums/post-comment/' + this.forumData._id, {
            comment: this.comment,
          });
        }
        if (response.success) {
          this.$notify.success({
            title: 'Success',
            message:
              (this.replyToComment ? 'Replied to the ' : ' Posted the ') + 'comment successfully',
          });
          await this.fetchComments();
          this.scrollToComments('comment-section');
          this.replyToComment = '';
          this.replyToUser = '';
          this.comment = '';
          window.CKEDITOR.instances[this.editorConfig.id].setData('');
        } else {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong',
          });
        }
      },
      async fetchComments() {
        this.totalComments = 0;
        let response = await postAPICall(
          'GET',
          '/forums/get-thread-comments/' + this.$route.params.forum_id
        );
        const comments = response.data || [];
        if (comments.length) {
          const topLevelComments = comments.filter(
            (comment) => !comment.replied_to || comment.replied_to === null
          );
          this.totalComments = topLevelComments.length;
          this.allComments = comments;
          this.comments = this.buildCommentHierarchy(comments);
        }
      },
      addComment() {
        this.replyToComment = '';
        this.replyToUser = '';
        this.comment = '';
        this.scrollToComments('post-comment-section');
      },
      openTag(tag) {
        this.$router.push({
          path: '/forums',
          query: {
            tag: tag,
            ...this.$route.query,
          },
        });
      },
      askQuestion() {
        let path = this.isApplicationUser ? '/ap/create-forum' : '/create-forum';
        this.$router.push({
          path,
        });
      },
      openForum(forum_id) {
        let url = this.isApplicationUser ? '/ap/forum/' : '/forum/';
        this.$router.push({
          path: url + forum_id,
        });
      },
      goBack() {
        this.$router.go(-1);
      },
    },
    watch: {
      '$route.params.forum_id'() {
        this.getNecessaryInfo();
      },
    },
  };
</script>
<style lang="scss">
  .initial {
    grid-template-columns: 35px auto;
    margin-top: 3px;
    margin-bottom: 3px;

    .icon {
      border: 1px solid var(--brand-500);
      text-align: center;
      border-radius: 50%;
      width: 30px;
      height: 30px;
      padding: 5px;
      background-color: transparent;

      .initial-text {
        font-size: 0.8em;
        font-weight: 400;

        span {
          color: var(--brand-500);
        }
      }
    }
  }

  .tag-box {
    border: 1px solid var(--page-border);
    border-radius: 16px;
    background-color: var(--card-color);

    .tag-header {
      font-weight: 400;
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: clamp(14px, 0.93vw, 18px);
      color: var(--black-950);
      border-bottom: 1px solid var(--page-border);
      padding: 8px;
    }

    .tag-list {
      padding: 12px;
    }

    .tag-row {
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      margin-bottom: 0.75rem;
    }
  }
</style>
